import { useNavigate } from "react-router-dom";
import { FilePen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { stashTailor, tailorUrl } from "@/lib/tailor";
import { cn } from "@/lib/utils";

export const TailorResumeButton = ({ job, compact = false, className }) => {
  const navigate = useNavigate();
  if (!job?.id) return null;
  const go = (e) => {
    e.stopPropagation();
    stashTailor({ jobId: job.id, job: { title: job.title, company: job.company }, ideas: [] });
    navigate(tailorUrl(job.id));
  };
  if (compact) return (
    <button type="button" onClick={go} className={cn("inline-flex items-center gap-1 rounded-full border border-[#D4AF37]/40 px-2 py-0.5 text-[10px] font-medium text-[#F3C649] transition-colors hover:bg-[#D4AF37]/10", className)} data-testid={`tailor-resume-${job.id}`}>
      <FilePen className="h-3 w-3" />Tailor resume
    </button>
  );
  return (
    <Button variant="outline" onClick={go} className={cn("rounded-full border-[#D4AF37]/50 text-[#F3C649] hover:bg-[#D4AF37]/10", className)} data-testid="tailor-resume-button">
      <FilePen className="h-4 w-4" />Tailor my resume
    </Button>
  );
};
